import React from "react";

const LegalCookies = () => (
  <section className="w-full bg-light-5 py-8 px-6">
    <h2 className="text-xl font-bold text-dark-1 mb-4">6. Cookies</h2>
    <p className="text-light-1 leading-relaxed">
      Le site utilise des cookies afin d’améliorer l’expérience utilisateur et d’analyser la fréquentation.
      Vous pouvez paramétrer vos préférences dans votre navigateur ou via le bandeau cookies.
    </p>
  </section>
);

export default LegalCookies;
